export default __webpack_public_path__ + "static/drugplaceholderImg-36215e8bef0b12e33bd1f936bf3b04a7.png";